import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter as Router } from 'react-router-dom';

import './assets/css/argon-design-system-react.min.css';
import './assets/css/nucleo.css';
import './assets/css/index.css';
import './assets/css/index.css';

import App from './components/App';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
	<React.StrictMode>
		<Router>
			<App />
		</Router>
	</React.StrictMode>,
	document.getElementById('root')
);

serviceWorkerRegistration.register();

reportWebVitals();
